<template>
    <v-card class="d-flex align-center justify-center" height="100%">
        <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
        <template v-if="!loading">
            <v-card width="auto" v-if="surveyId && orderId && !surveyResponseSended">
                <survey-response
                    :surveyId="surveyId"
                    withOrderId
                    :orderId="orderId"
                    @send="sendSurveyResponse"
                ></survey-response>
            </v-card>
            <v-card elevation="0" v-else>
                <v-alert type="success" closable>
                    Gracias por tu respuesta. Que disfrutes tu pedido!
                </v-alert>
                <v-btn color="primary" block @click="goHome">
                    <v-icon left>mdi-home</v-icon>Ir al inicio</v-btn>
            </v-card>
        </template>
    </v-card>
</template>
<script>
    import SurveyResponse from '../../../base/components/SurveyResponse'
    import SurveyViewConfigProvider from '../../providers/SurveyViewConfigProvider'

    export default {
        name: "SurveyResponseViaEmailPage",
        components: {SurveyResponse},
        data: () => ({
            loading: true,
            orderId: null,
            surveyId: null,
            surveyResponseSended: false
        }),
        async mounted(){
            this.loading = true
            this.loadOrderId()
            await this.loadSurvey()
            this.loading = false
        },
        methods: {
            goHome(){
                this.$router.push('/home')
            },
            sendSurveyResponse(){
                this.surveyResponseSended = true
            },
            async loadSurvey(){
                try {
                    const {data: {fetchSurveyViewConfig}} = await SurveyViewConfigProvider.fetchSurveyViewConfig()
                    const emailView = fetchSurveyViewConfig.find(item => item.view === 'email')
                    if(!emailView){
                        //TODO redirigir al home mostrando una alerta
                        alert('Disculpe las molestias, no encontramos la encuesta asignada a usted.')
                        this.goHome()
                        return
                    }
                    this.surveyId = emailView.survey.id
                } catch (error) {
                    console.error(error)
                }
            },
            loadOrderId(){
                this.orderId = this.$route.query.orderId
            }
        }
    }
</script>